<app-pagetitle
  title="Configurações Contatos"
  [breadcrumbItems]="breadCrumbItems"
></app-pagetitle>

<div class="card-body">
  <!-- Nav tabs -->
  <ul
    ngbNav
    #nav="ngbNav"
    [activeId]="1"
    class="nav-tabs nav-tabs-custom nav-justified"
  >
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <span class="d-block d-sm-none">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </span>
        <span class="d-none d-sm-block">Status</span>
      </a>
      <ng-template ngbNavContent>
        <ng-template [ngTemplateOutlet]="StatusMessages"></ng-template>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>
        <span class="d-block d-sm-none">
          <i class="fa fa-list" aria-hidden="true"></i>
        </span>
        <span class="d-none d-sm-block">Mensagens</span>
      </a>
      <ng-template ngbNavContent>
        <ng-template [ngTemplateOutlet]="Messages"></ng-template>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="text-muted"></div>
</div>

<ng-template #StatusMessages>
  @if(!podeVer){
    <app-no-access></app-no-access>
  }@else {

    <app-status-message-list></app-status-message-list>
  }
</ng-template>

<!-- Tab Content -->
<ng-template #Messages>
  @if(!podeVer){
    <app-no-access></app-no-access>
  }@else {
    <app-custom-message-list></app-custom-message-list>
  }
</ng-template>
<!-- end card-body -->
